define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.emptyStatusMessage = void 0;
    /* eslint-disable import/prefer-default-export */
    exports.emptyStatusMessage = { error: null, success: '' };
});
//# sourceMappingURL=emptyStatusMessage.js.map